import { ReactComponent as CloseIcon } from "../../../assets/icons/x-close.svg";
import { ReactComponent as SystemUpdateImage } from "../../../assets/images/system-update.svg";
import { useReleaseNotes } from "../utils/useReleaseNotes";

export function VersionReleaseCard() {
  const { data: releaseNotes, acknowledge } = useReleaseNotes();

  if (!releaseNotes || releaseNotes.acknowledged) return null;

  const handleClose = () => {
    if (releaseNotes.version) {
      acknowledge.mutate(releaseNotes.version);
    }
  };

  return (
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-orange-50 to-amber-50 px-6 py-5 shadow-[0_1px_2px_0_rgba(0,0,0,0.08)]">
      <button
        onClick={handleClose}
        aria-label="Dismiss release notes"
        className="absolute right-4 top-4 z-[1] flex h-9 w-9 items-center justify-center rounded-full bg-white shadow-[0_1px_2px_0_rgba(0,0,0,0.08)]"
      >
        <CloseIcon />
      </button>
      <SystemUpdateImage className="pointer-events-none absolute bottom-0 right-20 h-[95%]" />
      <div className="relative flex flex-col items-start gap-2 pr-[220px]">
        <div className="text-lg font-semibold text-black">What&apos;s new?</div>
        <p className="whitespace-pre-line text-sm text-black">{releaseNotes.message}</p>
        {releaseNotes.url && (
          <a
            href={releaseNotes.url}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-2 inline-flex items-center justify-center rounded-full bg-primary px-5 py-2.5 text-sm font-medium text-white transition duration-75 hover:opacity-80"
          >
            Learn More
          </a>
        )}
      </div>
    </div>
  );
}
